import type { MaybeRefOrGetter } from 'vue'

/**
 * Lets a sheet close on a backdrop click or Escape while its form is untouched, and asks
 * for confirmation instead once it has unsaved changes. Pass `guard` to the sheet's
 * `@interact-outside` and `@escape-key-down`; `confirm` runs `discard` and closes the dialog.
 * `SheetContent` has already prevented outside interactions that are not a dismiss of its own sheet.
 */
export function useDiscardGuard(isDirty: MaybeRefOrGetter<boolean>, discard: () => void) {
  const confirmOpen = ref(false)

  function guard(event: Event) {
    if (event.defaultPrevented) {
      return
    }
    if (toValue(isDirty)) {
      event.preventDefault()
      confirmOpen.value = true
    }
  }

  function confirm() {
    confirmOpen.value = false
    discard()
  }

  return { confirmOpen, guard, confirm }
}
